<template>
  <div>
    <BlocInfoPointDeVente/>
    <CartoGeneral class="mt-20"/>
    <ListesPanneau class="mt-20"/>
  </div>
</template>

<script>
import BlocInfoPointDeVente from '@/components/portail/blocProduits/BlocInfoPointDeVente';
import CartoGeneral from '@/components/portail/CartoGeneral';
import ListesPanneau from '@/components/portail/blocProduits/ListesPanneau';

export default {
  components: {
    BlocInfoPointDeVente,
    CartoGeneral,
    ListesPanneau,
  },
};
</script>
